import { Injectable } from '@angular/core';
import { TransactionAbstractService } from '~/services/api/web/transaction/transactionAbstractService';
import { TransactionMockService } from '~/services/api/web/transaction/transactionMockService';

//@TODO Implement this service
@Injectable()
export class TransactionService extends TransactionMockService implements TransactionAbstractService {
}